import { NavLink } from "react-router-dom";
import type { NavModule } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

interface NavItemProps {
  module: NavModule;
  collapsed?: boolean;
  onNavigate?: () => void;
}

export function NavItem({ module, collapsed, onNavigate }: NavItemProps) {
  const Icon = module.icon;
  const { t } = useLanguage();

  return (
    <NavLink
      to={module.path}
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          "thread-rail group relative flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
          isActive
            ? "bg-primary/10 text-primary"
            : "text-muted-foreground hover:bg-muted hover:text-foreground",
          collapsed && "justify-center px-0"
        )
      }
    >
      {({ isActive }) => (
        <span className="thread-rail flex w-full items-center gap-3" data-active={isActive}>
          <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
          {!collapsed && (
            <span className="flex-1 truncate">{t(module.label)}</span>
          )}
          {!collapsed && module.status === "upcoming" && (
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent" title={t("Upcoming module")} />
          )}
        </span>
      )}
    </NavLink>
  );
}
